import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './components/login/login.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {InfringementDetailsComponent} from './components/infringement-details/infringement-details.component';
import {ItSecurityCheckComponent} from './components/it-security-check/it-security-check.component';
import {AddInfringementComponent} from './components/add-infringement/add-infringement.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';

const routes: Routes = [
  {path: 'login', component: LoginComponent},
  { path: 'login/callback', component: OktaCallbackComponent },
  {path: 'dashboard', component: DashboardComponent, canActivate: [OktaAuthGuard]},
  {path: 'infringement-details/:identifier', component: InfringementDetailsComponent, canActivate: [OktaAuthGuard]},
  {path: 'it-security-check/:identifier', component: ItSecurityCheckComponent, canActivate: [OktaAuthGuard]},
  {path: 'add-infringement', component: AddInfringementComponent, canActivate: [OktaAuthGuard]},
  {path: '', component: DashboardComponent, canActivate: [OktaAuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
